import { call, put, select, race, all } from 'redux-saga/effects';
import { delay } from "redux-saga";
import { push } from 'react-router-redux';
import { ClaroSDKService } from '../../services/sdk/ClaroSDKService'
import { ClaroPayApi } from '../../services/api/ClaroPayApi'
import {
  setPaymentServiceConf,
  setPaymentServiceDataResult,
  setOCRScannerData,
  setPaymentServiceContacts,
  getFavoriteContactsSucess,
  getFavoriteContactsError,
  addContactToFavoritesError,
  getRecentContactsSucess,
  getRecentContactsError,
  getAmountOfTelcelPospagoSucess,
  getAmountOfTelcelPospagoError,
  getUserInfoSucess,
  getUserInfoLiteSucess,
  getPaymentMethodsSucess,
  getCommissionRulesSucess,
  setSelectedChipValuesSucess,
  getCommissionInfoSucess,
  getPlansSuccess,
  getPlansError,
  existCardSearsSuccess,
  existCardSearsError,
  getPlansCardSearsSuccess,
  getPaymentMethodsError,
  setCoordinates,
  getTrackIdSuccess,
  setTrackDataSuccess,
  setTrackStepsSuccess,
  getMessengerServiceSuccess,
  getMessengerServiceSearsSuccess,
  getMessengerServiceSearsError,
  getMessengerServiceError,
  getTelcelLineInformationError,
  getTelcelLineInformationSuccess,
  getScheduleTelcelBillPaymentContractSuccess,
  getAppSyncSuccess,
  getAppSyncError,
  getUserInfoError,
  getUserInfoLiteError,
  getUserInfoBothError,
  getUserInfoBothSuccess,
  getMessagesTokenizationSuccess,
  tokenizationOn,
  setSnackBarSuccess,
  setShowTermsInForm,
  setPaymentMethodsLoaded,
  getMessagesAnonFlowSuccess
} from '../actions/'
import {
  getCanEncript,
  getCanSendId,
  getHasCreditFromUrl,
  getCanSendClaroSocioValue,
  getUserInfoSelector,
  getUserInfoLiteSelector,
  paymentServiceConfSelector,
  isAnonimousSelector,
  isContainerTelcelSelector,
  getBundleVersionFromUrl,
  buldleParamsFromUrlSelector,
  getCanTokenCompleteSelector,
  getSnackBarSuccessSelector,
  getCanScannerSelector,
  getComissionRulesDiscount,
  getCardInfo,
  getOriginParamsSelector,
} from "../selectors/paymentsSelectors"
import { b64DecodeUnicode } from "../../components/organisms/ClaroList/utils"
import dummy from './dummyConfig.json';
import dummyPayment from '../../services/sdk/dummiePaymentMethods.json'
import { getUrlBalances } from '../../components/organisms/utils';

import messagingDefault from "../../services/messaging/miTelcel.json"
import messagingTokenizationDefault from "../../services/messaging/tokenization.json"

import { getMessagesDomiciliationSuccess } from '../actions/domiciliation'
import { ADVANCEMENT_CLARO_PAY, CREDIT_CLARO_PAY } from '../../constants';

export function* sagaGetPhoneNumber(action) {

  let { phoneNumber } = action.payload

  if (phoneNumber) {
    //yield put(actionUploaderPostFileErrorResponse(result));
    yield put(push('/telcel_prepago_monto'));
  } else {
    //yield put(actionUploaderPostFileResponse(result));
    yield put(push('/home'));
  }
}

export function* sagaGetPaymentServiceConf() {

  
  /////////////////////////
           //PRUEBAS
  /////////////////////////

    
  /*
  let { data } = dummy
  
  //console.log(JSON.stringify(data))
  yield put(setPaymentServiceConf(data));
  */
 
  try {
    const result = yield call(
      ClaroSDKService.getPaymentConf
    );

    console.log(`#### sagaGetPaymentServiceConf ####`)

    if (result !== "") {

      let { data } = result
      let parsedResult = JSON.parse(b64DecodeUnicode(data))
      yield put(setPaymentServiceConf(parsedResult));
    }

  } catch (e) {
    console.log(`#### sagaGetPaymentServiceConf parsedResult error ${e}`)
  }

}


export function* sagaSetPaymentServiceData(action) {
  try {
    // aca leer si hay snackbar
    const snackBarSuccess = yield select(getSnackBarSuccessSelector);
    const originAnalytic = yield select(getOriginParamsSelector);
    const discount = yield select(getComissionRulesDiscount);
    const cardInfo = yield select(getCardInfo);
    const isClaroPartner = yield select(
      (store) =>
        store.payments &&
        store.payments.PAYMENT_SERVICE_CONF &&
        store.payments.PAYMENT_SERVICE_CONF.isClaroPartner
    );
    /* 
    Debido a una condición de carrera presente en el renderizado del componente "BodyPaymentFormClaroSocio" linea 
    2423 y a múltiples efectos secundarios ocurriendo en diferentes tiempos, se opta por retirar del store directamente
    el valor proporcionado por la calculadora de comisiones, validando de forma segura si se es claro socio
    y el tipo de crédito con el que cuenta el usuario.

    a partir de estos datos se mantiene la lógica de negocio y se previene errores o afectaciones en otros componentes.
    */
    const discountCredit = {
      amountWithoutDiscount: 0,
      discountPercentage: 0,
      discountAmount: 0,
      discountFixedAmount: 0,
      amountWithoutCommissions: 0,
    };
    const cardInfoValue = (cardInfo && cardInfo.value) || false;
    const paymentMethodIsCredit =
      cardInfoValue == CREDIT_CLARO_PAY ||
      cardInfoValue == ADVANCEMENT_CLARO_PAY;
    const discountToSend = paymentMethodIsCredit ? discountCredit : discount;
    let ojectRequest =
      originAnalytic && originAnalytic.split(",")[0]
        ? {
            ...action.payload,
            [originAnalytic.split(",")[0]]: originAnalytic.split(",")[1]
              ? atob(originAnalytic.split(",")[1])
              : "",
          }
        : action.payload;

    if (snackBarSuccess) {
      ojectRequest = {
        ...ojectRequest,
        showSnackbar: snackBarSuccess,
      };
    }
    const ojectRequestcloned = Object.assign({}, ojectRequest);
    ojectRequestcloned["discount"] = discountToSend;

    let result;
    if (isClaroPartner) {
      console.warn("partner");
      result = yield call(ClaroSDKService.sendDataPayment, ojectRequestcloned);
    } else {
      console.warn("not claropartner");
      result = yield call(ClaroSDKService.sendDataPayment, ojectRequest);
    }

    yield put(setPaymentServiceDataResult(result));
    yield put(setSnackBarSuccess(undefined));


    /*
        if (isItBad) {
          yield put(actionUploaderPostFileErrorResponse(result));
          yield put(push('/launch'));
        } else {
          yield put(actionUploaderPostFileResponse(result));
          yield put(push('/participants'));
        }
    
        */
  } catch (error) {
    //yield put(actionUploaderPostFileErrorResponse(error));
    //yield put(push('/launch'));
    console.log(error);
  }
}

export function* sagaGetOCRScanner(action) {
    const { isClaroPartner, logo="", maxlength, format, regexAndroid, regexIos, aspectratio, orientation } = action;
    const canScanner = yield select(getCanScannerSelector);
    let result;  try {
    if(canScanner){
      result = yield call(
        ClaroSDKService.getNewOCRScanner,
        isClaroPartner,
        logo,
        maxlength,
        format,
        regexAndroid,
        regexIos,
        aspectratio,
        orientation
      );
    } else {
      result = yield call(
        ClaroSDKService.getOCRScanner,
        isClaroPartner,
        logo,
        maxlength
      );
    }

    //console.log(`#### sagaGetOCRScanner  ${result}`)
    yield put(setOCRScannerData(result));
  }
  catch (error) {
    console.log(error)
  }
}

export function* sagaGetPaymentContacts() {

  try {
    const result = yield call(
      ClaroSDKService.getPaymentContacts
    );

    if (result !== "") {
      //let { data } = result
      //let parsedResult = JSON.parse(b64DecodeUnicode(data));
      yield put(setPaymentServiceContacts(result));
    }
  }
  catch (error) {
    console.log(error)
  }
}


export function* getFavoriteContactsSaga(action) {
  try {
    const { serviceId } = action;
    const userInfo = yield select(getUserInfoSelector)
    const favoriteContacts = yield call(ClaroSDKService.getFavoriteContacts, serviceId, userInfo);
    yield put(getFavoriteContactsSucess(favoriteContacts));

    const contacts = yield call(ClaroSDKService.getPaymentContacts);

    return yield put(setPaymentServiceContacts(contacts));


  } catch (error) {
    // Bandera para evitar que al negar permisos de contactos se regrese mas de una pantalla en la navegación
    window.backContacts = true;
    return yield put(setPaymentServiceContacts(error));
/*     yield put(getFavoriteContactsError(error.message))
 */  }
}

export function* addContactToFavorites(action) {
  try {
    const { contact, serviceId } = action;
    const contactInfo = {
      contactInfo: {
        ...contact
      },
      serviceId
    };

    const contactWasAdded = yield call(ClaroSDKService.addFavorite, contactInfo);
    yield delay(400);
    if (contactWasAdded.response) {

      const favoriteContacts = yield call(ClaroSDKService.getFavoriteContacts, serviceId);
      yield put(getFavoriteContactsSucess(favoriteContacts));
      if(favoriteContacts){
        const recentContacts = yield call(ClaroSDKService.getRecentContacts, serviceId);
        return yield put(getRecentContactsSucess(recentContacts));
      }
      
    } else {
    }
  } catch (error) {

  }
}


export function* sagaDeleteFavoriteContact(action) {
  try {
    const { contact, serviceId } = action;
    const contactInfo = {
      contactInfo: {
        ...contact
      },
      serviceId
    };
    const isDeleted = yield call(ClaroSDKService.deleteFavoriteContact, contactInfo);
    yield delay(400);
    const contactListResponse = yield call(ClaroSDKService.getFavoriteContacts, serviceId);
    if (isDeleted.response) {
      const recentContacts = yield call(ClaroSDKService.getRecentContacts, serviceId);
      yield put(getRecentContactsSucess(recentContacts));
      return yield put(getFavoriteContactsSucess(contactListResponse));
      
    }
  }
  catch (error) {
    /* TODO: */
  }
}

export function* getRecentContactsSaga(action) {
  try {
    const { serviceId } = action;
    const recentContacts = yield call(ClaroSDKService.getRecentContacts, serviceId);
    yield delay(400);
    yield put(getRecentContactsSucess(recentContacts));
  } catch (error) {
    yield put(getRecentContactsError(error.message))
  }
}

export function* addContactToRecents(action) {
  try {
    const { contact, serviceId } = action;
    const contactInfo = {
      contactInfo: {
        ...contact
      },
      serviceId
    };

    const contactWasAdded = yield call(ClaroSDKService.addContactToRecents, contactInfo);
    yield delay(400);
    if (contactWasAdded.response) {
      const recentContacts = yield call(ClaroSDKService.getRecentContacts, serviceId);
      return yield put(getRecentContactsSucess(recentContacts));
    } else {
      yield put(getRecentContactsError(error.message))
    }
  } catch (error) {

  }
}
 /// Telcel
 export function* sagaGetAmountOfTelcelPospago(action) {
  const { telephoneNumber, serviceId, needsDelay } = action;
  const reference = telephoneNumber
  const isContainerTelcel = yield select(isContainerTelcelSelector);
  const endPointData = getUrlBalances(isContainerTelcel, serviceId, needsDelay)
  try {
    const balance = yield call(
      ClaroPayApi.getBalances, reference, serviceId, endPointData
    );
    return yield put(getAmountOfTelcelPospagoSucess(balance))
  } catch (error) {
    return yield put(getAmountOfTelcelPospagoSucess(error))
  }
}

// User info both
export function* sagaGetUserInfoBoth() {
    try {
      const { responses, timeout } = yield race({
        responses: all([
          call(ClaroSDKService.getUserInfo),
          call(ClaroSDKService.getUserInfoLite)
        ]),
        timeout: delay(30000),
      });

      if (timeout) {
        yield put(getUserInfoBothError());
      } else {
        yield put(getUserInfoSucess(responses[0]));
        yield put(getUserInfoLiteSucess(responses[1]));
        yield put(getUserInfoBothSuccess());
      }
    } catch (error) {
      console.log(error)
      yield put(getUserInfoBothError());
    }
}

 /// user info
 export function* sagaGetUserInfo() {
  try {
    const userInfo = yield call(ClaroSDKService.getUserInfo);
    return yield put(getUserInfoSucess(userInfo));
  } catch (error){
    return yield put(getUserInfoError());
  }
}

/// user info
export function* sagaGetUserInfoLite() {
  try {
    const userInfo = yield call(ClaroSDKService.getUserInfoLite);
    return yield put(getUserInfoLiteSucess(userInfo));
  } catch (error){
    return yield put(getUserInfoLiteError());
  }
}

/// payment methods getPaymentMethods
export function* sagaGetPaymentMethods(action) {

  //return yield put(getPaymentMethodsSucess(dummyPayment));

  const state = yield select(state => state.payments);
  const { paymentMethodsLoaded, isContainerTelcel, isTemporalClaroId, startEventLoginIsOver } = state;

  const canSendId = yield select(getCanSendId)
  const hasCredit = yield select(getHasCreditFromUrl)
  const canSendClaroSocioValue = yield select(getCanSendClaroSocioValue)
  const userInfo = yield select(getUserInfoSelector)
  const serviceId =  action.serviceId
  const isClaroPartner =  action.isClaroPartner
  const isTemporal = action.isTemporal
  try {
    const paymentMethods = yield call(
      ClaroSDKService.getPaymentMethods, 
      canSendId, 
      hasCredit, 
      serviceId,
      isClaroPartner,
      canSendClaroSocioValue,
      userInfo
    );

	if (isContainerTelcel) {
		if (
			!paymentMethodsLoaded &&
			isTemporalClaroId &&
			paymentMethods &&
			paymentMethods.cardList &&
			paymentMethods.cardList.length === 0 &&
			!paymentMethods.hasN2
		) {
			yield put(setShowTermsInForm(true));
			yield put(setPaymentMethodsLoaded(true));
		}
		
		if (
			(!isTemporalClaroId || startEventLoginIsOver) &&
			paymentMethods &&
			paymentMethods.cardList &&
			paymentMethods.cardList.length === 0 &&
			!paymentMethods.hasN2
		) {
			yield put(setShowTermsInForm(true));
		}

		if (
			(!isTemporalClaroId || startEventLoginIsOver) &&
			paymentMethods &&
			paymentMethods.cardList &&
			(
				paymentMethods.cardList.length > 0 ||
				paymentMethods.hasN2
			)
		) {
			yield put(setShowTermsInForm(false))
		}
	}

    return yield put(getPaymentMethodsSucess(paymentMethods));
  } catch (error){
    return yield put(getPaymentMethodsError(error))
  }
}

///  commission rules
export function* getCommissionRules(action) {
  const { serviceId, amountValueForCommission, mark, selectCardId, cardType, sdkVersion } = action;
  try {
    const commissions = yield call(
      ClaroSDKService.getCommissionRules, 
      serviceId,
      amountValueForCommission,
      mark,
      selectCardId,
      cardType,
      sdkVersion
    );
    return yield put(getCommissionRulesSucess(commissions));
  } catch (error){

  }
}

export function* setSelectedChipValuesSaga(action) {
  const { productId, amountValue } = action;
  try {
    
    return yield put(setSelectedChipValuesSucess({"productId": productId, "amountValue":amountValue }));
  } catch (error){

  }
}

///  commission info
export function* getCommissionInfo(action) {
  const { serviceId, merchantId, amount, isClaroPay, cardId, sdkVersion, isClaroPartner, trackId, referenceMsisdn} = action;
  const userInfo = yield select(getUserInfoSelector)
  const isContainerTelcel = yield select(isContainerTelcelSelector);
  const bundleParamsFromUrl = yield select(buldleParamsFromUrlSelector)
  try {
    const commissions = yield call(
      ClaroPayApi.getCommissionInfo, 
      serviceId,
      merchantId,
      amount,
      isClaroPay,
      cardId,
      sdkVersion,
      isClaroPartner,
      trackId,
      userInfo,
      referenceMsisdn,
      isContainerTelcel,
      bundleParamsFromUrl
    );
    yield delay(300);
    console.warn("commission rules to put",commissions)
      return yield put(getCommissionRulesSucess(commissions));
  } catch (error){

  }
}

/// plans
export function* getPlans(action) {
  const { serviceId, planType, isReset=false } = action;
  const isContainerTelcel = yield select(isContainerTelcelSelector);
  try {
    if(isReset){
      return yield put(getPlansError(""))
    } else {
      const plans = yield call(ClaroPayApi.getPlans, serviceId, planType, isContainerTelcel);
      yield delay(200);
      return yield put(getPlansSuccess(plans));
    }
  } catch (error){
    return yield put(getPlansError(error))
  }
}

///  exist card Sears
export function* existCardSears(action) {
  const { cardNumber, serviceId } = action;
  try {
    const  existCardSears = yield call(ClaroSDKService.existCardSears, cardNumber, serviceId);
    return yield put(existCardSearsSuccess(existCardSears));
  } catch (error){
    return yield put(existCardSearsError(error));
  }
}

///  get plans card Sears
export function* getPlansCardSearsSaga(action) {
  const { cardSearsNumber, serviceId } = action;
  try {
    const  plansCardSears = yield call(ClaroSDKService.getPlansCardSears, cardSearsNumber, serviceId);
    return yield put(getPlansCardSearsSuccess(plansCardSears));
  } catch (error){
  }
}

export function* getCoordinatesUser() {
  try {
    const result = yield call(
      ClaroSDKService.getCoordinates
    );
    yield delay(200);
    return yield put(setCoordinates(result));
  }
  catch (error) {
    console.log(error)
  }
}

export function* sagaGetTrackId() {
  try {
    const userInfo = yield select(getUserInfoSelector)
    const trackId = yield call(ClaroSDKService.getTrackId, userInfo);
    yield delay(200);
    return yield put(getTrackIdSuccess(trackId));
  } catch (error) {}
}

export function* setTrackData(action) {
  const { trackTxId } = action;
  const userInfo = yield select(getUserInfoSelector)
  try {
    const value = yield call(ClaroSDKService.setTxData, trackTxId, userInfo);
    yield delay(200);
    return yield put(setTrackDataSuccess(value));
  } catch(error) {}
}

export function* sagaSetTrackSteps(action) {
  const { trackTxId, step } = action;
  const userInfo = yield select(getUserInfoSelector)
  try {
    const value = yield call(ClaroSDKService.postTrack, trackTxId, step, null, null, userInfo);
    yield delay(200);
    return yield put(setTrackStepsSuccess(value));
  } catch(error) {}
}

export function* executeTaggeoSaga(action) {
  const { params } = action;
  const canEncript = yield select(getCanEncript)
  const userInfo = yield select(getUserInfoSelector)
  try {
    yield call(ClaroSDKService.executeTaggeo, params, canEncript, userInfo);
  } catch(error) {}
}

export function* getMessengerServiceSaga(action) {
  const { flux, code } = action;
  try {
    const messages = yield call(ClaroSDKService.messagerService, flux, code);
    if(flux === "PagosProgramados"){
      return yield put(getMessagesDomiciliationSuccess(messages.length ? messages : messagingDefault));
    } else if(flux === "TokenizationCard"){
      return yield put(getMessagesTokenizationSuccess(messages.length ? messages : messagingTokenizationDefault));
    }else if(flux === "FlujoAnonimo"){
      return yield put(getMessagesAnonFlowSuccess(messages.length? messages: messagingDefault));
    }else{
      return yield put(getMessengerServiceSuccess(messages.length ? messages : messagingDefault));
    }
  } catch(error) {
    return yield put(getMessengerServiceSuccess(messagingDefault))
  }
}

export function* getMessengerServiceSearsSaga(action) {
  const { flux, code } = action;
  try {
    const messages = yield call(ClaroSDKService.messagerServiceSears, flux, code);
    return yield put(getMessengerServiceSearsSuccess(messages.length ? messages : messagingDefault));
  } catch(error) {
    return yield put(getMessengerServiceSearsError(messagingDefault))
  }
}


export function* getTelcelLineInformationSaga() {
  const userInfo = yield select(getUserInfoSelector)
  const userInfoLite = yield select(getUserInfoLiteSelector)
  const paymentsConfig = yield select(paymentServiceConfSelector);
  const isAnonimous = yield select(isAnonimousSelector);
  const {msisdn: msisdnUserInfo, username} = userInfo;
  const {msisdn: msisdnPayments} = paymentsConfig;  
  const claroId = isAnonimous ? '' : username;
  const {perfilTelcel} = userInfoLite;
  let lineNumber = isAnonimous && msisdnPayments ? msisdnPayments : msisdnUserInfo;
      lineNumber = lineNumber.slice(-10);

  try {
    const lineTelcelInformation = yield call(
      ClaroPayApi.getTelcelLineInformationService, 
      lineNumber, 
      claroId,
      perfilTelcel
    );
    console.log(userInfoLite,perfilTelcel);
    return yield put(getTelcelLineInformationSuccess(lineTelcelInformation));
  } catch(error) {
    return yield put(getTelcelLineInformationError(error))
  }
}

/// schedule telcel contract
export function* getScheduleTelcelContract(params) {
   /** PRUEBAS
  let { data } = dummyScheduleTelcel;
  return yield put(getScheduleTelcelBillPaymentContractSuccess(data));
   */

  const userInfo = yield select(getUserInfoSelector);
  const { bank, maximumAmount, minimumAmount, periodicity, product, providerService } = params;

  try {
    const contract = yield call(
      ClaroPayApi.getScheduleTelcelBillPaymentContractService, 
      bank,
      maximumAmount,
      minimumAmount,
      userInfo.msisdn.substr(3,12), 
      periodicity,
      product,
      providerService
    );
    return yield put(getScheduleTelcelBillPaymentContractSuccess(contract));
  } catch(error) {
    return yield put(getScheduleTelcelBillPaymentContractSuccess(""))
  }
}
const isTokenizationOn = (appSyncData, bankId, isContainerTelcel) => {
  const onTokenization = isContainerTelcel? `${process.env.REACT_APP_SERVICE_ENABLE_TOKENIZATION_WEB_ON_TELCEL}` === `true` : `${process.env.REACT_APP_SERVICE_ENABLE_TOKENIZATION_WEB_ON}` === `true`;
  console.debug("isContainerTelcel, ", isContainerTelcel, " onTokenization, ", onTokenization);
  if(onTokenization) {
    if(appSyncData && appSyncData.banks && appSyncData.banks.length){
      const bankInbursa = appSyncData.banks.find((it) => it.idBank === bankId || it.idBank === "000");
      return bankInbursa && bankInbursa.toggles && bankInbursa.toggles.DD_WEB_TOKENIZATION_ON;
    } else {
      return isContainerTelcel?
        `${process.env.REACT_APP_SERVICE_ENABLE_TOKENIZATION_WEB_TELCEL}` === `true`
        :
        `${process.env.REACT_APP_SERVICE_ENABLE_TOKENIZATION_WEB}` === `true`;
    }
  } else {
    return false;
  }
}
export function* getAppSyncSaga() {
  try {
    const canGetAppSync = yield select(state => state.payments.canGetAppSync);
    const isContainerTelcel = yield select(isContainerTelcelSelector);
    const bundleVersionSelect = yield select(getBundleVersionFromUrl); 
    const {
      // Ambos
      REACT_APP_APPSYNC_COUNTRY_ID,
      REACT_APP_APPSYNC_BANK_ID,
      // Contenedor
      REACT_APP_APPSYNC_BUNDLE_ID,
      REACT_APP_APPSYNC_BUNDLE_VERSION,
      //Claro Pay
      REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY,
      REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY,
    } = process.env;

    const countryId = REACT_APP_APPSYNC_COUNTRY_ID;
    const bankId = REACT_APP_APPSYNC_BANK_ID;
    const bundleId = isContainerTelcel 
      ? REACT_APP_APPSYNC_BUNDLE_ID 
      : REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY;
    const bundleVersion = isContainerTelcel
      ? (bundleVersionSelect || REACT_APP_APPSYNC_BUNDLE_VERSION)
      : (bundleVersionSelect || REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY)

    if (canGetAppSync) {
      const { response, timeout } = yield race({
        response: call(ClaroSDKService.getAppSync, bundleId, countryId, bankId, bundleVersion),
        timeout: delay(15000)
      });
      if (timeout) {
        yield call(getAppSyncDirectSaga);
      } else {
        const canTokenComplete = yield select(getCanTokenCompleteSelector);
        console.debug("canTokenComplete, ", canTokenComplete, isTokenizationOn(response, process.env.REACT_APP_APPSYNC_BANK_ID, isContainerTelcel));
        yield put(tokenizationOn(isTokenizationOn(response, process.env.REACT_APP_APPSYNC_BANK_ID, isContainerTelcel) && canTokenComplete));
        return yield put(getAppSyncSuccess(response));
      }
    } else {
      yield call(getAppSyncDirectSaga);
    }    
  } catch (error) {
    yield call(getAppSyncDirectSaga);
  }
}

export function* getAppSyncDirectSaga() {
  try {
    const isContainerTelcel = yield select(isContainerTelcelSelector);
    const bundleVersion = yield select(getBundleVersionFromUrl);

    const { response, timeout } = yield race({
      response: !isContainerTelcel
        ? call(ClaroPayApi.getAppSyncApi, bundleVersion)
        : call(ClaroPayApi.getAppSyncTelcelApi, bundleVersion),
      timeout: delay(15000)
    });
    const canTokenComplete = yield select(getCanTokenCompleteSelector);
    console.debug("canTokenComplete, ", canTokenComplete, isTokenizationOn(response, process.env.REACT_APP_APPSYNC_BANK_ID, isContainerTelcel));
    yield put(tokenizationOn(isTokenizationOn(response, process.env.REACT_APP_APPSYNC_BANK_ID, isContainerTelcel) && canTokenComplete));
    return timeout
      ? yield put(getAppSyncError(error))
      : yield put(getAppSyncSuccess(response));
  } catch (error) {
    return yield put(getAppSyncError(error));
  }
}

export function* deleteAllCardsSaga(action) {
  const fullToken = action.tokenFull ? action.tokenFull : yield call(ClaroSDKService.getFullToken);
  const userinfo = yield select(getUserInfoSelector);
  yield call(ClaroPayApi.deleteAllCardsApi, userinfo, fullToken);
}